import { Container, Loading } from '@elotech/components';
import React, { useEffect, useState } from 'react';

import { CodigoModulosReactEnum } from '../../type/enum';
import { IFrame } from '../iframe';

type Props = {
  codigoModulo: CodigoModulosReactEnum;
  entidade: string;
};

const UnicoCamposDinamicosComponent: React.FC<Props> = ({
  codigoModulo,
  entidade
}) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window?.document?.addEventListener(
      'iframe-onInit',
      e => {
        setLoading(false);
      },
      false
    );
  }, []);

  return (
    <Container breadcrumb>
      <Loading loading={loading} />
      <IFrame
        path={`/unico/campos-dinamicos?iframe=true&codigoModulo=${codigoModulo}&entidade=${entidade}`}
      />
    </Container>
  );
};

export { UnicoCamposDinamicosComponent };
